import { render, staticRenderFns } from "./SurfaceDesignTexture.vue?vue&type=template&id=3bb9396e"
import script from "./SurfaceDesignTexture.vue?vue&type=script&lang=js"
export * from "./SurfaceDesignTexture.vue?vue&type=script&lang=js"
import style0 from "./SurfaceDesignTexture.vue?vue&type=style&index=0&id=3bb9396e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports